module.exports = __webpack_public_path__ + "img/17_40.53c2e62e.png";